import React from 'react';
import PropTypes from 'prop-types';
import { css } from 'styled-components';
import { Field } from 'react-final-form';
import FontStyles from 'constants/font-styles';
import Colors from 'constants/colors';
import i18n from 'i18n';
import { applyStyles } from 'util/helpers';
import DatepickerContainer from './components/DatepickerContainer';
import CustomMedia from 'util/custom-media-query';
import Tag from 'components/common/Tag';

const DatepickerField = ({
  className,
  name,
  label,
  validate,
  required,
  ...inputProps
}) => (
  <div className={className}>
    <Field
      name={name}
      validate={validate}
      render={({ input, meta }) => (
        <React.Fragment>
          {label && (
            <label htmlFor={name}>
              <span>{label}</span>
              {required && <Tag>{i18n.t('common:required')}</Tag>}
            </label>
          )}
          <DatepickerContainer
            input={input}
            meta={meta}
            inputProps={inputProps}
          />
        </React.Fragment>
      )}
    />
  </div>
);

DatepickerField.propTypes = {
  className: PropTypes.string,
  name: PropTypes.string.isRequired,
  label: PropTypes.string,
  validate: PropTypes.func,
  maxLength: PropTypes.number,
  placeholder: PropTypes.string,
  required: PropTypes.bool,
  disabled: PropTypes.bool,
  notes: PropTypes.arrayOf(PropTypes.string),
  minDate: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  maxDate: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  disable: PropTypes.arrayOf(PropTypes.string)
};

const commonStyle = css`
  label {
    ${FontStyles.text5}

    display: flex;
    color: ${Colors.black1};
    align-items: center;

    span {
      display: block;
    }
  }

  .tag {
    ${FontStyles.text11};

    display: block;
    width: 38px;
    height: 22px;
    line-height: 22px !important;
    background-color: ${Colors.orange1};
    color: ${Colors.white1};
    text-align: center;
    font-style: normal;
    border-radius: 4px;
  }
`;

const pcStyle = CustomMedia.greaterThan('umedium')`
  margin: 40px 0;

  label {
    margin: 0 0 12px 0;

    span {
      margin-right: 8px;
    }
  }
`;

const spStyle = CustomMedia.lessThan('medium')`
  width: 100%;
  padding: 0 16px;
  margin: 32px 0;

  label {
    margin: 0 0 12px 0;

    span {
      margin-right: 4px;
    }
  }
`;

export default applyStyles(DatepickerField)(commonStyle, pcStyle, spStyle);



// WEBPACK FOOTER //
// ./src/components/common/DatepickerField/index.js